import { onBeforeUnmount, ref } from 'vue';
import { getMobileClient } from '@/services/mobile-client';

const compactViewportQuery = '(max-width: 720px)';

export function isCompactViewport(): boolean {
  if (getMobileClient()) return true;
  return (
    typeof window !== 'undefined' &&
    (window.matchMedia?.(compactViewportQuery).matches ?? window.innerWidth <= 720)
  );
}

/** 初始化时即判断窄屏，避免手机首屏先挂载桌面组件。 */
export function useCompactViewport() {
  const media =
    typeof window !== 'undefined' ? window.matchMedia?.(compactViewportQuery) : undefined;
  const compact = ref(isCompactViewport());
  const update = () => {
    compact.value = isCompactViewport();
  };
  media?.addEventListener('change', update);
  onBeforeUnmount(() => media?.removeEventListener('change', update));
  return compact;
}
